import validate from "/app/node_modules/.pnpm/nuxt@3.20.0_@parcel+watcher@2.5.1_@types+node@24.10.0_@vue+compiler-sfc@3.5.22_db0@0.3.4_esli_mfn6ruyltul7hbkay32lah5rqm/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.20.0_@parcel+watcher@2.5.1_@types+node@24.10.0_@vue+compiler-sfc@3.5.22_db0@0.3.4_esli_mfn6ruyltul7hbkay32lah5rqm/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}